const MuiCardContent = {
  root: {
    padding: 24,
  },
}
export default MuiCardContent
